import api from "./api";

const diagnosisService = {};
const endpoint = "/diagnosis";

diagnosisService.getDiagnoses = function (filter) {
  return api.get(endpoint, { params: filter }).then(({ data }) => data);
};

/**
 * @method getById
 * @description Trae un diagnóstico por id. Usado por DiagnosisSelect cuando
 *              recibe un value que no está en su lista cargada por default
 *              (caso UC-REG-127: el diagnóstico se aplicó vía event bus
 *              cross-section sin haber sido seleccionado en este SELECT).
 *              UC-REG-129.
 * @param {string} id - ObjectId del diagnóstico
 * @returns {Promise<Object>} `{ _id, code, description, ... }`
 */
diagnosisService.getById = function (id) {
  return api.get(`${endpoint}/${id}`).then(({ data }) => data);
};

/**
 * @method search
 * @description Busca diagnósticos CIE-10 por código o descripción
 * @param {string} query - Texto de búsqueda
 * @returns {Promise} Lista de diagnósticos coincidentes
 */
diagnosisService.search = function (query) {
  return api
    .get("/diagnosis/search", { params: { q: query } })
    .then(({ data }) => data);
};

export default diagnosisService;
